import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { BlogpageService } from '../../blogpage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ArticleData } from 'src/app/shared/utilities/interfaces';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-article-content-container',
  templateUrl: './article-content-container.component.html',
  styleUrls: ['./article-content-container.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class ArticleContentContainerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() pageData: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private blogPageService: BlogpageService,
    private router: Router,
    private meta: MetaService,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.getUrl = this.router.url;
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  articleData!: ArticleData;
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };

  ngOnInit(): void {}
  ngOnChanges(): void {
    const data = this.pageData;
    if (data != null) {
      this.articleData = {
        tag: data?.fields?.category,
        header: data?.fields?.title,
        author: data?.fields?.authorName,
        createdDate: data?.sys?.createdAt,
        readingTime: data?.fields?.readingTime,
        personaimage: {
          url: data?.fields?.authorPersona?.fields?.file?.url,
          alt: data?.fields?.authorPersona?.fields?.title,
        },
        bannerimage: {
          url: data?.fields?.blogImage?.fields?.file?.url,
          alt: data?.fields?.blogImage?.fields?.title,
        },
        richTextTop: data?.fields?.blogContentTop,
        richTextBottom: data?.fields?.blogContentBottom,
        //description: data?.fields?.blogContentTop?.content[0]?.content[0]?.value,
        blogContentAdPanel: {
          header: data?.fields?.blogContentAdPanel?.fields?.title,
          button: {
            url: data?.fields?.blogContentAdPanel?.fields?.buttons[0]?.fields
              ?.redirectLink,
            text: data?.fields?.blogContentAdPanel?.fields?.buttons[0]?.fields
              ?.buttonText,
            target:
              data?.fields?.blogContentAdPanel?.fields?.buttons[0]?.fields
                ?.actionType,
          },
        },
      };
      if (data?.fields?.title) {
        this.metaBody.title = data.fields?.title;
      } else {
        this.metaBody.title =
          'Verto: Cross-border payments platform for businesses';
      }
      if (data?.fields?.blogContentTop) {
        this.metaBody.description =
          data?.fields?.blogContentTop.content[0].content[0].value;
      } else {
        this.metaBody.description =
          'Verto: Cross-border payments platform for businesses across the globe.';
      }
      this.metaBody.type = 'Blog Article';
      this.metaBody.url = this.getUrl;
      this.metaBody.image = this.articleData?.bannerimage?.url;
      this.meta.updateOG(this.metaBody);
      this.meta.updateMeta(data?.seoMetadataReference?.fields ?? this.metaBody);
    }
  }

  social(a: string) {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    let title = this.articleData?.header;
    let url = `https://verto.co${this.getUrl}`;
    let twitterHandle = 'Verto';
    let facebook = 'https://facebook.com/sharer/sharer.php?u=' + url;
    let twitter =
      'https://twitter.com/intent/tweet?url=' +
      url +
      '&text=' +
      title +
      '&via=' +
      twitterHandle;
    let linkedin =
      'https://www.linkedin.com/shareArticle?url=' + url + '&title=' + title;

    let b = '';

    if (a === 'linkedin') {
      b = linkedin;
    }
    if (a === 'twitter') {
      b = twitter;
    }
    if (a === 'facebook') {
      b = facebook;
    }

    let params = `width=600,height=400,left=100,top=100`;

    window.open(b, a, params);
  }
}
